<div class="main">
    <dx-scroll-view id="scrollview">
        <div class="dx-field-title" translate>fileTransfersRenamingParameters.pageTitle</div>
        <div class="dx-field selector">
            <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
            <div class="dx-field-value">
                <app-file-transfer-picker #fileTransferPicker [fileTransfers]="fileTransfers" [isRequired]="true" (selectedItemChange)="filterChanged($event)"></app-file-transfer-picker>
            </div>
        </div>
        <br />
        <div class="dx-fieldset">
            <div class="dx-fieldset-header" translate>fileTransfersRenamingParameters.lblTestParameters</div>
            <div class="dx-field selector">
                <div class="dx-field-label" translate>
                    fileTransfersRenamingParameters.lblInitialFileName<span class="dx-field-item-required-mark">*</span>
                </div>
                <div class="dx-field-value">
                    <dx-text-box [(value)]="initialFileName"></dx-text-box>
                </div>
            </div>
            <div class="dx-field selector">
                <div class="dx-field-label" translate>fileTransfersRenamingParameters.lblRenamedFileName</div>
                <div class="flex dx-field-value">
                    <div style="flex-grow: 1; padding-right: 10px;"><dx-text-box [value]="renamedFileName" [readOnly]="true"></dx-text-box></div>
                    <dx-button class="save" icon="refresh" (onClick)="testRenamingParameters()" [disabled]="!selectedFileTransfer || initialFileName.length === 0"></dx-button>
                </div>
            </div>
        </div>
        <br />
        <br />
        <div>
            <div style="float:left;width:60%">
                <div class="dx-fieldset-header" translate>fileTransfersRenamingParameters.lblParameters</div>
                <dx-data-grid #renamingParameters
                              [dataSource]="dataSource"
                              keyExpr="id"
                              hoverStateEnabled="true"
                              style="max-height:700px;"
                              [wordWrapEnabled]="true"
                              [errorRowEnabled]="false"
                              (onRowDblClick)="onRowDblClick($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="parameter" [displayFormat]="'fileTransfersRenamingParameters.lblParametersCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="parameter" [caption]="'fileTransfersRenamingParameters.lblParameter' | translate">
                    </dxi-column>
                    <dxi-column dataField="rank" [caption]="'fileTransfersRenamingParameters.lblRank' | translate" [width]="100"></dxi-column>
                    <dxi-column [width]="120" cellTemplate='actionsCellTemplate'></dxi-column>
                    <div *dxTemplate="let cell of 'actionsCellTemplate'">
                        <dx-button class="edit" icon="edit" [hint]="'_commons.edit' | translate"
                                   (onClick)="displayEditPopup(cell.data)"></dx-button>
                        <dx-button class="delete" icon="trash" [hint]="'_commons.delete' | translate"
                                   (onClick)="deleteRenamingParameter(cell.data.id)"></dx-button>
                    </div>
                </dx-data-grid>
            </div>
            <div style="float:right;width:35%">
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>fileTransfersRenamingParameters.lblRecognizedVariables</div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%DateTime%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%DateTime%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarDateTime</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%DateTimeUtc%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%DateTimeUtc%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarDateTimeUtc</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%DateTime:format%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%DateTime:format%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarDateTimeFormat</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%DateTimeUtc:format%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%DateTimeUtc:format%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarDateTimeUtcFormat</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%InitFileName%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%InitFileName%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarInitFileName</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%InitFileNameExtension%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%InitFileNameExtension%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarInitFileNameExtension</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%InitFileNameWithExtension%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%InitFileNameWithExtension%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarInitFileNameWithExtension</div>
                    </div>
                    <div class="dx-field variable">
                        <div class="dx-field-label click" (click)="displayNewPopup('%InitFileName:x_y%')" [title]="'fileTransfersRenamingParameters.lblClickToAdd' | translate">%InitFileName:x_y%</div>
                        <div class="dx-field-value" translate>fileTransfersRenamingParameters.lblVarInitFileNameXY</div>
                    </div>
                </div>
            </div>
        </div>
    </dx-scroll-view>
</div>
<br />
<div class="main" *ngIf="selectedFileTransfer && dataSource && dataSource.length > 0">
    
</div>

<!-- New & Edit popup -->
<dx-popup [title]="'fileTransfersRenamingParameters.popupTitle' | translate" [height]="290"
    [(visible)]="isPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="isPopupVisible">
            <dx-validation-group #renamingParameterValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfersRenamingParameters.lblParameter<span
                            class="dx-field-item-required-mark">
                            *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedRenamingParameter.parameter">
                            <dx-validator>
                                <dxi-validation-rule type="required"
                                    [message]="'fileTransfersRenamingParameters.msgParameterRequired' | translate">
                                </dxi-validation-rule>
                                <dxi-validation-rule type="stringLength" [max]="100"
                                    [message]="'_validators.maxLength100' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>fileTransfersRenamingParameters.lblRank</div>
                    <div class="dx-field-value" style="width:100px;float:left">
                        <dx-text-box [(value)]="selectedRenamingParameter.rank">
                            <dx-validator>
                                <dxi-validation-rule type="numeric" [message]="'_validators.numeric' | translate">
                                </dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="0" [max]="1000"
                                    [message]="'_validators.range1000' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dx-validation-group>
            <div class="flex bottom-buttons">
                <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createRenamingParameter()"
                    [visible]="isNew"></dx-button>
                <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateRenamingParameter()"
                    [visible]="!isNew" [useSubmitBehavior]="true"></dx-button>
                <dx-button class="delete" [text]="'_commons.cancel' | translate"
                    (onClick)="this.isPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate"
    [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
